/**
 * Delete-confirmation copy for departments and positions.
 *
 * Both FKs are `ON DELETE SET NULL`, so a delete silently unassigns linked rows
 * instead of failing — the counts have to be spelled out before confirming.
 */

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

const withImpact = (name, parts) => {
  if (!parts.length) return `Delete "${name}"? This cannot be undone.`;
  return `Delete "${name}"? ${parts.join(' and ')} will be unassigned and keep no link to it. This cannot be undone.`;
};

export const buildDepartmentDeleteMessage = ({ name, employeeCount = 0, positionCount = 0 }) => {
  const parts = [];
  if (employeeCount > 0) parts.push(plural(employeeCount, 'employee'));
  if (positionCount > 0) parts.push(plural(positionCount, 'position'));
  return withImpact(name, parts);
};

export const buildPositionDeleteMessage = ({ name, employeeCount = 0 }) =>
  withImpact(name, employeeCount > 0 ? [plural(employeeCount, 'employee')] : []);
